// Caricatore condiviso di pdf.js: worker servito da /pdf.worker.min.js (estensione .js → MIME corretto
// su qualunque server statico). Se il worker non parte, si ripiega sul rendering nel thread principale.
let libPromise = null;
export function pdfjs() {
  if (!libPromise) {
    libPromise = import("pdfjs-dist/build/pdf.min.mjs").then((lib) => {
      lib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;
      return lib;
    });
  }
  return libPromise;
}

// Apre un PDF dai byte; al primo errore del worker ritenta senza worker
export async function apriPdf(arrayBuffer) {
  const lib = await pdfjs();
  const dati = new Uint8Array(arrayBuffer);
  try {
    return await lib.getDocument({ data: dati.slice(), isEvalSupported: false }).promise;
  } catch (e) {
    const msg = String(e?.message || e);
    if (/worker|import|module|script/i.test(msg)) {
      lib.GlobalWorkerOptions.workerSrc = "";
      lib.GlobalWorkerOptions.workerPort = null;
      return await lib.getDocument({ data: dati.slice(), isEvalSupported: false, disableWorker: true }).promise;
    }
    throw e;
  }
}
